import { Controller } from "@hotwired/stimulus"

// Contatori della barra laterale (Layout.js 31a5bd1): ogni 60 s rilegge le richieste non lette e la coda di revisione
// e aggiorna i due badge; gli errori si ignorano. Ai cambi di pagina i badge sono già rifatti dal server.
export default class extends Controller {
  static targets = ["coda", "unread"]
  static values = { intervallo: { type: Number, default: 60000 } }

  connect() {
    this.timer = setInterval(() => this.refresh(), this.intervalloValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  // La barra del cassetto (schermi piccoli) è nascosta: lascia fare a quella visibile.
  get visibile() {
    return this.element.getClientRects().length > 0
  }

  async refresh() {
    if (!this.visibile) return
    const [unread, coda] = await Promise.all([
      this.conta("/api/demo-requests/unread-count", "count"),
      this.conta("/api/admin/segnalazioni/conteggio", "aperte")
    ])
    if (unread !== null) this.mostra(this.unreadTargets, unread)
    if (coda !== null) this.mostra(this.codaTargets, coda)
  }

  async conta(url, chiave) {
    try {
      const r = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      if (!r.ok) return null
      const n = Number((await r.json())[chiave])
      return Number.isFinite(n) ? n : null
    } catch (_) {
      return null
    }
  }

  mostra(badges, n) {
    badges.forEach((el) => {
      el.hidden = !(n > 0)
      el.textContent = n > 99 ? "99+" : String(n)
    })
  }
}
